'use client';

import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { User, MailIcon, ArrowRightIcon, MessageSquare, Send } from 'lucide-react';

import React, { useState } from 'react';
import { useRouter } from 'next/navigation';
import { toast } from 'sonner';
import { data } from 'autoprefixer';




const Form = () => {

  const initValues = { name: '', subject: '', content: '' };
  const initState = { values: initValues };
  const [state, setState] = useState(initState);
  const { values } = state;

  const router = useRouter();


  const validateInput = (inputValue, allowParentheses = false) => {
    const regexPattern = allowParentheses
      ? /^[a-zA-Z0-9\sàâéèêëîïôöùûüçÀÂÉÈÊËÎÏÔÖÙÛÜÇ!?. :()"\-']*$/
      : /^[a-zA-Z0-9\sàâéèêëîïôöùûüçÀÂÉÈÊËÎÏÔÖÙÛÜÇ!?. :()"\-']*$/;
    return regexPattern.test(inputValue);
  };

  const inputCleaner = () => {
    setState((prev) => ({
      ...prev,
      values: initValues,
    }));
  };

  const handleChange = ({ target }) =>
    setState((prev) => ({
      ...prev,
      values: {
        ...prev.values,
        [target.name]: target.value,
      },
    }));

  const onSubmit = async (e) => {
    e.preventDefault();

    const missingFields = [];
    if (!validateInput(values.name)) {
      toast.warning('Mauvais format du nom et prénom. 😕');
    }
    if (!validateInput(values.subject)) {
      toast.warning('Mauvais format du sujet. 😕');
    }
    if (!validateInput(values.content)) {
      toast.warning('Mauvais format du contenu. 😕');
    }
    if (!values.name) {
      missingFields.push('Nom & Prénom');
    }
    if (!values.subject) {
      missingFields.push('Sujet');
    }
    if (!values.content) {
      missingFields.push('Contenu');
    }
    if (missingFields.length > 0) {
      toast.warning(
        `Veuillez remplir le${missingFields.length > 1 ? 's' : ''} champ${
          missingFields.length > 1 ? 's' : ''
        }: ${missingFields.join(', ')}`
      );
      return;
    }

    if (
      values.name.length <= 35 &&
      values.subject.length <= 100 &&
      values.content.length <= 500
    ) {
      const promise = () =>
        new Promise((resolve) =>
          setTimeout(() => resolve({ name: 'Sonner' }), 5000)
        );
      toast.promise(promise, {
        loading: 'Envoi du message...',
        success: () => {
          return 'Message envoyé ! Je vous recontacte prochainement 😃';
        },
        error: "Erreur lors de l'envoi du message.",
      });

      // const response = await fetch('/api/sendEmail')
      // console.log(values)
      // console.log(values.name)
      // console.log(values.content)
      // console.log(values.subject)
      const response = await fetch('/api/sendEmail', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: values.name,
          subject: values.subject,
          content: values.content,
        }),
      });
      // console.log(response)
      inputCleaner();
      setTimeout(() => {
        router.push('/');
      }, 50);
    }
  };

  return (
    <form className='flex flex-col gap-y-4'>
      {/* INPUT  */}
      <div className='relative flex items-center'>
        <Input
          type='name'
          id='name'
          placeholder='Nom prénom'
          required
          name='name'
          onChange={handleChange}
        />
        <User className='absolute right-6' size={20} />
      </div>
      {/* INPUT  */}
      <div className='relative flex items-center'>
        <Input
          type='text'
          id='subject'
          placeholder='Sujet'
          required
          name='subject'
          onChange={handleChange}
        />
        <MailIcon className='absolute right-6' size={20} />
      </div>
      {/* TEXTAREA  */}
      <div className='relative flex items-center'>
        <Textarea
          placeholder='Hello, voici mon message...'
          required
          name='content'
          onChange={handleChange}
        />
        <MessageSquare className='absolute top-4 right-6' size={20} />
      </div>
      {/* <Button
        onClick={onSubmit}
        variant='neo'
        className='flex justify-center items-center gap-x-1 max-w-[166px] dark:border-[#6D28D9] dark:border dark:border-2 dark:shadow-[5px_5px_0px_0px_#6D28D9] overflow-hidden'
      >
        Parlons-en
        <ArrowRightIcon size={20} />
      </Button> */}
      <button
        onClick={onSubmit}
        className='btn rounded-md border-white/50 max-w-[170px] px-8  duration-300 flex items-center justify-center mx-auto overflow-hidden hover:border-accent group  !border !border-2 !border-[#FA6E58] shadow shadow-[5px_5px_0px_0px_#FA6E58] hover:translate-y-1 hover:translate-x-1 transition-all hover:!shadow-none dark:!border-[#6D28D9] dark:shadow-[5px_5px_0px_0px_#6D28D9] h-10 px-4 py-2 font-medium'
      >
        <span className='group-hover:translate-x-[120%] group-hover:opacity-0 transition-all duration-500'>
          Parlons-en !
        </span>
        <Send className='-translate-x-[120%] rotate-12 opacity-0 group-hover:flex group-hover:-translate-y-0  group-hover:-translate-x-0 group-hover:opacity-100 transition-all duration-300 absolute text-[22px]' />
      </button>
    </form>
  );
};

export default Form;
